import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3d449bc3 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _cff88b18 = () => interopDefault(import('../pages/cl_payments/index.vue' /* webpackChunkName: "pages/cl_payments/index" */))
const _005ccef9 = () => interopDefault(import('../pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */))
const _615252cc = () => interopDefault(import('../pages/data_export/index.vue' /* webpackChunkName: "pages/data_export/index" */))
const _6f6ade5e = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _b5469ecc = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _1ad2f2b1 = () => interopDefault(import('../pages/payment_links/index.vue' /* webpackChunkName: "pages/payment_links/index" */))
const _03e45242 = () => interopDefault(import('../pages/sales_data/index.vue' /* webpackChunkName: "pages/sales_data/index" */))
const _155542c2 = () => interopDefault(import('../pages/smartlock_logs/index.vue' /* webpackChunkName: "pages/smartlock_logs/index" */))
const _352cc7ec = () => interopDefault(import('../pages/surveys/index.vue' /* webpackChunkName: "pages/surveys/index" */))
const _35106ce4 = () => interopDefault(import('../pages/version_up.vue' /* webpackChunkName: "pages/version_up" */))
const _4b098830 = () => interopDefault(import('../pages/visit_logs/index.vue' /* webpackChunkName: "pages/visit_logs/index" */))
const _7a363c76 = () => interopDefault(import('../pages/clients/attention.vue' /* webpackChunkName: "pages/clients/attention" */))
const _ca049a5a = () => interopDefault(import('../pages/clients/heatmap.vue' /* webpackChunkName: "pages/clients/heatmap" */))
const _8898e730 = () => interopDefault(import('../pages/data_export/new.vue' /* webpackChunkName: "pages/data_export/new" */))
const _3480e033 = () => interopDefault(import('../pages/login/deputy.vue' /* webpackChunkName: "pages/login/deputy" */))
const _2a9936f5 = () => interopDefault(import('../pages/login/forget_id.vue' /* webpackChunkName: "pages/login/forget_id" */))
const _da2dcf22 = () => interopDefault(import('../pages/login/re_password.vue' /* webpackChunkName: "pages/login/re_password" */))
const _46f6c309 = () => interopDefault(import('../pages/settings/ai_changes/index.vue' /* webpackChunkName: "pages/settings/ai_changes/index" */))
const _7dfc5a86 = () => interopDefault(import('../pages/settings/ai_integration_manage.vue' /* webpackChunkName: "pages/settings/ai_integration_manage" */))
const _bd1ba3d2 = () => interopDefault(import('../pages/settings/ai_integration.vue' /* webpackChunkName: "pages/settings/ai_integration" */))
const _1609ab50 = () => interopDefault(import('../pages/settings/akerun-callback.vue' /* webpackChunkName: "pages/settings/akerun-callback" */))
const _c579641c = () => interopDefault(import('../pages/settings/alert.vue' /* webpackChunkName: "pages/settings/alert" */))
const _3ea40198 = () => interopDefault(import('../pages/settings/alerts/index.vue' /* webpackChunkName: "pages/settings/alerts/index" */))
const _4095d618 = () => interopDefault(import('../pages/settings/calendar.vue' /* webpackChunkName: "pages/settings/calendar" */))
const _485f204e = () => interopDefault(import('../pages/settings/calendars/index.vue' /* webpackChunkName: "pages/settings/calendars/index" */))
const _72af0dea = () => interopDefault(import('../pages/settings/card.vue' /* webpackChunkName: "pages/settings/card" */))
const _a55f46c8 = () => interopDefault(import('../pages/settings/cl_payments/index.vue' /* webpackChunkName: "pages/settings/cl_payments/index" */))
const _4e0f23ad = () => interopDefault(import('../pages/settings/client_ranks.vue' /* webpackChunkName: "pages/settings/client_ranks" */))
const _4260c521 = () => interopDefault(import('../pages/settings/clients/index.vue' /* webpackChunkName: "pages/settings/clients/index" */))
const _1be5bbb3 = () => interopDefault(import('../pages/settings/company_groups/index.vue' /* webpackChunkName: "pages/settings/company_groups/index" */))
const _90225f1a = () => interopDefault(import('../pages/settings/company_stats.vue' /* webpackChunkName: "pages/settings/company_stats" */))
const _67179db6 = () => interopDefault(import('../pages/settings/content_sequences/index.vue' /* webpackChunkName: "pages/settings/content_sequences/index" */))
const _336ea777 = () => interopDefault(import('../pages/settings/contents/index.vue' /* webpackChunkName: "pages/settings/contents/index" */))
const _6a6df25e = () => interopDefault(import('../pages/settings/courses/index.vue' /* webpackChunkName: "pages/settings/courses/index" */))
const _36b90e7c = () => interopDefault(import('../pages/settings/data_export/index.vue' /* webpackChunkName: "pages/settings/data_export/index" */))
const _31ba566b = () => interopDefault(import('../pages/settings/discounts/index.vue' /* webpackChunkName: "pages/settings/discounts/index" */))
const _72d0f032 = () => interopDefault(import('../pages/settings/email.vue' /* webpackChunkName: "pages/settings/email" */))
const _2f498ee2 = () => interopDefault(import('../pages/settings/headquarter.vue' /* webpackChunkName: "pages/settings/headquarter" */))
const _594da20f = () => interopDefault(import('../pages/settings/instructors/index.vue' /* webpackChunkName: "pages/settings/instructors/index" */))
const _529a6f4e = () => interopDefault(import('../pages/settings/items/index.vue' /* webpackChunkName: "pages/settings/items/index" */))
const _618d4d60 = () => interopDefault(import('../pages/settings/kiosk_devices/index.vue' /* webpackChunkName: "pages/settings/kiosk_devices/index" */))
const _13cfcd8a = () => interopDefault(import('../pages/settings/lm_point_transactions/index.vue' /* webpackChunkName: "pages/settings/lm_point_transactions/index" */))
const _cb706e34 = () => interopDefault(import('../pages/settings/marketing_channels/index.vue' /* webpackChunkName: "pages/settings/marketing_channels/index" */))
const _bb6bf2e6 = () => interopDefault(import('../pages/settings/menus/index.vue' /* webpackChunkName: "pages/settings/menus/index" */))
const _9ffe03d2 = () => interopDefault(import('../pages/settings/message_templates.vue' /* webpackChunkName: "pages/settings/message_templates" */))
const _77679ef5 = () => interopDefault(import('../pages/settings/password.vue' /* webpackChunkName: "pages/settings/password" */))
const _028a8d92 = () => interopDefault(import('../pages/settings/payment_histories/index.vue' /* webpackChunkName: "pages/settings/payment_histories/index" */))
const _723ff35c = () => interopDefault(import('../pages/settings/payment_methods/index.vue' /* webpackChunkName: "pages/settings/payment_methods/index" */))
const _48854f82 = () => interopDefault(import('../pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _1e9257a3 = () => interopDefault(import('../pages/settings/reserve_settings/index.vue' /* webpackChunkName: "pages/settings/reserve_settings/index" */))
const _742519d2 = () => interopDefault(import('../pages/settings/reserve.vue' /* webpackChunkName: "pages/settings/reserve" */))
const _97c89504 = () => interopDefault(import('../pages/settings/resources/index.vue' /* webpackChunkName: "pages/settings/resources/index" */))
const _4ee6cb1a = () => interopDefault(import('../pages/settings/sales_data/index.vue' /* webpackChunkName: "pages/settings/sales_data/index" */))
const _2db45507 = () => interopDefault(import('../pages/settings/school_slots/index.vue' /* webpackChunkName: "pages/settings/school_slots/index" */))
const _27143cea = () => interopDefault(import('../pages/settings/sections/index.vue' /* webpackChunkName: "pages/settings/sections/index" */))
const _443a08c5 = () => interopDefault(import('../pages/settings/shop_fixed.vue' /* webpackChunkName: "pages/settings/shop_fixed" */))
const _e0d54d92 = () => interopDefault(import('../pages/settings/staff_roles/index.vue' /* webpackChunkName: "pages/settings/staff_roles/index" */))
const _6a786b30 = () => interopDefault(import('../pages/settings/staffs/index.vue' /* webpackChunkName: "pages/settings/staffs/index" */))
const _0fb866b7 = () => interopDefault(import('../pages/settings/team.vue' /* webpackChunkName: "pages/settings/team" */))
const _19075072 = () => interopDefault(import('../pages/settings/time_zones/index.vue' /* webpackChunkName: "pages/settings/time_zones/index" */))
const _179d6c92 = () => interopDefault(import('../pages/settings/training_events/index.vue' /* webpackChunkName: "pages/settings/training_events/index" */))
const _9e2bb966 = () => interopDefault(import('../pages/settings/training_lists/index.vue' /* webpackChunkName: "pages/settings/training_lists/index" */))
const _12b6752a = () => interopDefault(import('../pages/settings/training_machines/index.vue' /* webpackChunkName: "pages/settings/training_machines/index" */))
const _d0e1c54c = () => interopDefault(import('../pages/settings/training_muscles/index.vue' /* webpackChunkName: "pages/settings/training_muscles/index" */))
const _787732a8 = () => interopDefault(import('../pages/settings/trial.vue' /* webpackChunkName: "pages/settings/trial" */))
const _b03cc5a6 = () => interopDefault(import('../pages/settings/zoom.vue' /* webpackChunkName: "pages/settings/zoom" */))
const _1ab1459c = () => interopDefault(import('../pages/visit_logs/analytics.vue' /* webpackChunkName: "pages/visit_logs/analytics" */))
const _e6dacee0 = () => interopDefault(import('../pages/settings/data_export/new.vue' /* webpackChunkName: "pages/settings/data_export/new" */))
const _197ba440 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d12475ac = () => interopDefault(import('../pages/settings/ai_changes/_uid.vue' /* webpackChunkName: "pages/settings/ai_changes/_uid" */))
const _7dd6fb6c = () => interopDefault(import('../pages/settings/school_slots/_uid.vue' /* webpackChunkName: "pages/settings/school_slots/_uid" */))
const _d0d2617c = () => interopDefault(import('../pages/settings/ticket_sets/_filter.vue' /* webpackChunkName: "pages/settings/ticket_sets/_filter" */))
const _21947c2a = () => interopDefault(import('../pages/bodyscans/_filter.vue' /* webpackChunkName: "pages/bodyscans/_filter" */))
const _1c306c60 = () => interopDefault(import('../pages/client_trends/_filter.vue' /* webpackChunkName: "pages/client_trends/_filter" */))
const _d450479e = () => interopDefault(import('../pages/lessons/_filter.vue' /* webpackChunkName: "pages/lessons/_filter" */))
const _517df926 = () => interopDefault(import('../pages/points/_filter.vue' /* webpackChunkName: "pages/points/_filter" */))
const _ba2bd1cc = () => interopDefault(import('../pages/ticket_sets/_filter.vue' /* webpackChunkName: "pages/ticket_sets/_filter" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/calendar/",
    component: _3d449bc3,
    pathToRegexpOptions: {"strict":true},
    name: "calendar"
  }, {
    path: "/cl_payments/",
    component: _cff88b18,
    pathToRegexpOptions: {"strict":true},
    name: "cl_payments"
  }, {
    path: "/clients/",
    component: _005ccef9,
    pathToRegexpOptions: {"strict":true},
    name: "clients"
  }, {
    path: "/data_export/",
    component: _615252cc,
    pathToRegexpOptions: {"strict":true},
    name: "data_export"
  }, {
    path: "/events/",
    component: _6f6ade5e,
    pathToRegexpOptions: {"strict":true},
    name: "events"
  }, {
    path: "/login/",
    component: _b5469ecc,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/payment_links/",
    component: _1ad2f2b1,
    pathToRegexpOptions: {"strict":true},
    name: "payment_links"
  }, {
    path: "/sales_data/",
    component: _03e45242,
    pathToRegexpOptions: {"strict":true},
    name: "sales_data"
  }, {
    path: "/smartlock_logs/",
    component: _155542c2,
    pathToRegexpOptions: {"strict":true},
    name: "smartlock_logs"
  }, {
    path: "/surveys/",
    component: _352cc7ec,
    pathToRegexpOptions: {"strict":true},
    name: "surveys"
  }, {
    path: "/version_up/",
    component: _35106ce4,
    pathToRegexpOptions: {"strict":true},
    name: "version_up"
  }, {
    path: "/visit_logs/",
    component: _4b098830,
    pathToRegexpOptions: {"strict":true},
    name: "visit_logs"
  }, {
    path: "/clients/attention/",
    component: _7a363c76,
    pathToRegexpOptions: {"strict":true},
    name: "clients-attention"
  }, {
    path: "/clients/heatmap/",
    component: _ca049a5a,
    pathToRegexpOptions: {"strict":true},
    name: "clients-heatmap"
  }, {
    path: "/data_export/new/",
    component: _8898e730,
    pathToRegexpOptions: {"strict":true},
    name: "data_export-new"
  }, {
    path: "/login/deputy/",
    component: _3480e033,
    pathToRegexpOptions: {"strict":true},
    name: "login-deputy"
  }, {
    path: "/login/forget_id/",
    component: _2a9936f5,
    pathToRegexpOptions: {"strict":true},
    name: "login-forget_id"
  }, {
    path: "/login/re_password/",
    component: _da2dcf22,
    pathToRegexpOptions: {"strict":true},
    name: "login-re_password"
  }, {
    path: "/settings/ai_changes/",
    component: _46f6c309,
    pathToRegexpOptions: {"strict":true},
    name: "settings-ai_changes"
  }, {
    path: "/settings/ai_integration_manage/",
    component: _7dfc5a86,
    pathToRegexpOptions: {"strict":true},
    name: "settings-ai_integration_manage"
  }, {
    path: "/settings/ai_integration/",
    component: _bd1ba3d2,
    pathToRegexpOptions: {"strict":true},
    name: "settings-ai_integration"
  }, {
    path: "/settings/akerun-callback/",
    component: _1609ab50,
    pathToRegexpOptions: {"strict":true},
    name: "settings-akerun-callback"
  }, {
    path: "/settings/alert/",
    component: _c579641c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-alert"
  }, {
    path: "/settings/alerts/",
    component: _3ea40198,
    pathToRegexpOptions: {"strict":true},
    name: "settings-alerts"
  }, {
    path: "/settings/calendar/",
    component: _4095d618,
    pathToRegexpOptions: {"strict":true},
    name: "settings-calendar"
  }, {
    path: "/settings/calendars/",
    component: _485f204e,
    pathToRegexpOptions: {"strict":true},
    name: "settings-calendars"
  }, {
    path: "/settings/card/",
    component: _72af0dea,
    pathToRegexpOptions: {"strict":true},
    name: "settings-card"
  }, {
    path: "/settings/cl_payments/",
    component: _a55f46c8,
    pathToRegexpOptions: {"strict":true},
    name: "settings-cl_payments"
  }, {
    path: "/settings/client_ranks/",
    component: _4e0f23ad,
    pathToRegexpOptions: {"strict":true},
    name: "settings-client_ranks"
  }, {
    path: "/settings/clients/",
    component: _4260c521,
    pathToRegexpOptions: {"strict":true},
    name: "settings-clients"
  }, {
    path: "/settings/company_groups/",
    component: _1be5bbb3,
    pathToRegexpOptions: {"strict":true},
    name: "settings-company_groups"
  }, {
    path: "/settings/company_stats/",
    component: _90225f1a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-company_stats"
  }, {
    path: "/settings/content_sequences/",
    component: _67179db6,
    pathToRegexpOptions: {"strict":true},
    name: "settings-content_sequences"
  }, {
    path: "/settings/contents/",
    component: _336ea777,
    pathToRegexpOptions: {"strict":true},
    name: "settings-contents"
  }, {
    path: "/settings/courses/",
    component: _6a6df25e,
    pathToRegexpOptions: {"strict":true},
    name: "settings-courses"
  }, {
    path: "/settings/data_export/",
    component: _36b90e7c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-data_export"
  }, {
    path: "/settings/discounts/",
    component: _31ba566b,
    pathToRegexpOptions: {"strict":true},
    name: "settings-discounts"
  }, {
    path: "/settings/email/",
    component: _72d0f032,
    pathToRegexpOptions: {"strict":true},
    name: "settings-email"
  }, {
    path: "/settings/headquarter/",
    component: _2f498ee2,
    pathToRegexpOptions: {"strict":true},
    name: "settings-headquarter"
  }, {
    path: "/settings/instructors/",
    component: _594da20f,
    pathToRegexpOptions: {"strict":true},
    name: "settings-instructors"
  }, {
    path: "/settings/items/",
    component: _529a6f4e,
    pathToRegexpOptions: {"strict":true},
    name: "settings-items"
  }, {
    path: "/settings/kiosk_devices/",
    component: _618d4d60,
    pathToRegexpOptions: {"strict":true},
    name: "settings-kiosk_devices"
  }, {
    path: "/settings/lm_point_transactions/",
    component: _13cfcd8a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-lm_point_transactions"
  }, {
    path: "/settings/marketing_channels/",
    component: _cb706e34,
    pathToRegexpOptions: {"strict":true},
    name: "settings-marketing_channels"
  }, {
    path: "/settings/menus/",
    component: _bb6bf2e6,
    pathToRegexpOptions: {"strict":true},
    name: "settings-menus"
  }, {
    path: "/settings/message_templates/",
    component: _9ffe03d2,
    pathToRegexpOptions: {"strict":true},
    name: "settings-message_templates"
  }, {
    path: "/settings/password/",
    component: _77679ef5,
    pathToRegexpOptions: {"strict":true},
    name: "settings-password"
  }, {
    path: "/settings/payment_histories/",
    component: _028a8d92,
    pathToRegexpOptions: {"strict":true},
    name: "settings-payment_histories"
  }, {
    path: "/settings/payment_methods/",
    component: _723ff35c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-payment_methods"
  }, {
    path: "/settings/profile/",
    component: _48854f82,
    pathToRegexpOptions: {"strict":true},
    name: "settings-profile"
  }, {
    path: "/settings/reserve_settings/",
    component: _1e9257a3,
    pathToRegexpOptions: {"strict":true},
    name: "settings-reserve_settings"
  }, {
    path: "/settings/reserve/",
    component: _742519d2,
    pathToRegexpOptions: {"strict":true},
    name: "settings-reserve"
  }, {
    path: "/settings/resources/",
    component: _97c89504,
    pathToRegexpOptions: {"strict":true},
    name: "settings-resources"
  }, {
    path: "/settings/sales_data/",
    component: _4ee6cb1a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-sales_data"
  }, {
    path: "/settings/school_slots/",
    component: _2db45507,
    pathToRegexpOptions: {"strict":true},
    name: "settings-school_slots"
  }, {
    path: "/settings/sections/",
    component: _27143cea,
    pathToRegexpOptions: {"strict":true},
    name: "settings-sections"
  }, {
    path: "/settings/shop_fixed/",
    component: _443a08c5,
    pathToRegexpOptions: {"strict":true},
    name: "settings-shop_fixed"
  }, {
    path: "/settings/staff_roles/",
    component: _e0d54d92,
    pathToRegexpOptions: {"strict":true},
    name: "settings-staff_roles"
  }, {
    path: "/settings/staffs/",
    component: _6a786b30,
    pathToRegexpOptions: {"strict":true},
    name: "settings-staffs"
  }, {
    path: "/settings/team/",
    component: _0fb866b7,
    pathToRegexpOptions: {"strict":true},
    name: "settings-team"
  }, {
    path: "/settings/time_zones/",
    component: _19075072,
    pathToRegexpOptions: {"strict":true},
    name: "settings-time_zones"
  }, {
    path: "/settings/training_events/",
    component: _179d6c92,
    pathToRegexpOptions: {"strict":true},
    name: "settings-training_events"
  }, {
    path: "/settings/training_lists/",
    component: _9e2bb966,
    pathToRegexpOptions: {"strict":true},
    name: "settings-training_lists"
  }, {
    path: "/settings/training_machines/",
    component: _12b6752a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-training_machines"
  }, {
    path: "/settings/training_muscles/",
    component: _d0e1c54c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-training_muscles"
  }, {
    path: "/settings/trial/",
    component: _787732a8,
    pathToRegexpOptions: {"strict":true},
    name: "settings-trial"
  }, {
    path: "/settings/zoom/",
    component: _b03cc5a6,
    pathToRegexpOptions: {"strict":true},
    name: "settings-zoom"
  }, {
    path: "/visit_logs/analytics/",
    component: _1ab1459c,
    pathToRegexpOptions: {"strict":true},
    name: "visit_logs-analytics"
  }, {
    path: "/settings/data_export/new/",
    component: _e6dacee0,
    pathToRegexpOptions: {"strict":true},
    name: "settings-data_export-new"
  }, {
    path: "/",
    component: _197ba440,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/settings/ai_changes/:uid/",
    component: _d12475ac,
    pathToRegexpOptions: {"strict":true},
    name: "settings-ai_changes-uid"
  }, {
    path: "/settings/school_slots/:uid/",
    component: _7dd6fb6c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-school_slots-uid"
  }, {
    path: "/settings/ticket_sets/:filter?/",
    component: _d0d2617c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-ticket_sets-filter"
  }, {
    path: "/bodyscans/:filter?/",
    component: _21947c2a,
    pathToRegexpOptions: {"strict":true},
    name: "bodyscans-filter"
  }, {
    path: "/client_trends/:filter?/",
    component: _1c306c60,
    pathToRegexpOptions: {"strict":true},
    name: "client_trends-filter"
  }, {
    path: "/lessons/:filter?/",
    component: _d450479e,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-filter"
  }, {
    path: "/points/:filter?/",
    component: _517df926,
    pathToRegexpOptions: {"strict":true},
    name: "points-filter"
  }, {
    path: "/ticket_sets/:filter?/",
    component: _ba2bd1cc,
    pathToRegexpOptions: {"strict":true},
    name: "ticket_sets-filter"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
